import React, { Component } from 'react'
import { Table } from 'reactstrap'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { openModalWithContainer } from './../reducers/modals'
import Resource from '../Resource'

// import '../styles/SettingsContainer.css'

const Headers = [
  {
    label: 'Name',
    key: 'name',
  },
  { label: 'Start', key: 'startDate' },
  { label: 'End', key: 'endDate' },
  { label: 'Description', key: 'desc' },
  { label: 'Total', key: 'participants_total' },
  { label: 'Participants', key: 'participants' },
  { label: 'Actions', key: 'actions' },
]

export default class StudiesContainer extends Component {
  state = {
    sortAttr: 'name',
    sortDir: 'DESC',
  }

  render() {
    const { sortAttr, sortDir } = this.state
    const { me } = this.props

    const sortStudies = (studies) => {
      let filteredUsers = studies

      return filteredUsers.sort((a, b) => {
        const r =
          typeof a[sortAttr] === 'string'
            ? `${a[sortAttr]}`.localeCompare(`${b[sortAttr]}`)
            : b[sortAttr] - a[sortAttr]
        return sortDir === 'ASC' ? -r : r
      })
    }

    const mapRoleLabel = (roleId) => {
      switch (roleId) {
        case 1:
          return 'Admin'
        case 2:
          return 'Trainer'
        case 3:
        default:
          return 'User'
      }
    }
    const renderHeader = ({ key, label }) => {
      return (
        <th
          key={key}
          onClick={() => {
            if (sortAttr === key) {
              this.setState({ sortAttr, sortDir: sortDir === 'ASC' ? 'DESC' : 'ASC' })
            } else {
              this.setState({ sortAttr: key, sortDir: 'DESC' })
            }
          }}
        >
          {label}
          <div style={{ float: 'right' }}>
            {sortAttr === key ? (sortDir === 'ASC' ? '⬆' : '⬇') : ''}
          </div>
        </th>
      )
    }

    const ListParticipants = (users) => {
      if (users.length === 0) return ''

      const list = users.map((user) => user.firstName + ' ' + user.lastName + ', ')
      list[list.length - 1] = list[list.length - 1].slice(0, -2)
      return <p>{list}</p>
    }

    return (
      <Resource collection path={['sections']} placeholder={[]}>
        {(sections) => (
          <Resource collection path={['studies']} placeholder={[]}>
            {(studies, { onCreateItem, onUpdateItem, onDeleteItem, dispatch }) => (
              <div id="UsersContainer">
                <h3 className="tab-header">
                  Studies
                  <div style={{ float: 'right' }}>
                    <div
                      className="btn btn-sm btn-primary"
                      onClick={() =>
                        dispatch(
                          openModalWithContainer('StudyContainer', {
                            study: null,
                            onSave: onCreateItem,
                            me: me,
                          })
                        )
                      }
                    >
                      Add Study
                    </div>
                  </div>
                </h3>
                <Table className="table-element">
                  <thead>
                    <tr key="test">{Headers.map(renderHeader)}</tr>
                  </thead>
                  <tbody>
                    {console.log('STUDIES', studies)}
                    {sortStudies(studies).map((study) => (
                      <tr key={study.id}>
                        <td>
                        {study.name}
                        </td>
                        <td>{study.startDate}</td>
                        <td>{study.endDate}</td>
                        <td>{study.description}</td>
                        <td>{study.users ? study.users.length : ''}</td>
                        <td>{study.users ? ListParticipants(study.users) : ''}</td>
                        <td>
                          <a
                            href="#"
                            onClick={() =>
                              dispatch(
                                openModalWithContainer('StudyContainer', {
                                  study: study,
                                  onDelete: onDeleteItem,
                                  onSave: onUpdateItem,
                                  me: me,
                                })
                              )
                            }
                          >
                            Edit
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Resource>
        )}
      </Resource>
    )
  }
}
